var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 5.66667H42.6667C45.6122 5.66667 48 8.05448 48 11V45.6667C48 48.6122 45.6122 51 42.6667 51H5.33333C2.38781 51 0 48.6122 0 45.6667V11C0 8.05448 2.38781 5.66667 5.33333 5.66667H8V1.66667C8 0.930286 8.59695 0.333332 9.33333 0.333332H12C12.7364 0.333332 13.3333 0.930286 13.3333 1.66667V5.66667H34.6667V1.66667C34.6667 0.930286 35.2636 0.333332 36 0.333332H38.6667C39.403 0.333332 40 0.930286 40 1.66667V5.66667ZM5.33333 45.6667H42.6667V16.3333H5.33333V45.6667ZM12 37.6667H25.3333C26.0697 37.6667 26.6667 37.0697 26.6667 36.3333V33.6667C26.6667 32.9303 26.0697 32.3333 25.3333 32.3333H12C11.2636 32.3333 10.6667 32.9303 10.6667 33.6667V36.3333C10.6667 37.0697 11.2636 37.6667 12 37.6667ZM36 27H12C11.2636 27 10.6667 26.403 10.6667 25.6667V23C10.6667 22.2636 11.2636 21.6667 12 21.6667H36C36.7364 21.6667 37.3333 22.2636 37.3333 23V25.6667C37.3333 26.403 36.7364 27 36 27Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.9e36e82f5e229f134f5f5ba197112c39.svg";
export { ForwardRef as ReactComponent };